import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import { Tooltip } from '@vimily/bonjoro-ui-components-v2/Tooltip';
import React from 'react';
import { QueryStatus } from 'react-query';
import AttributeListItem from '~/BonjorosList/components/Todo/DetailsPanel/AttributeListItem';
import { useZiggy } from '~/react-hooks/use-ziggy';

import { Attribute } from '~/types/models';

const TOP_INTEGRATIONS = [
  {
    name: 'Shopify',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_shopify.svg',
  },
  {
    name: 'Ontraport',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_ontraport.svg',
  },
  {
    name: 'Hubspot',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_hubspot.svg',
  },
  {
    name: 'ActiveCampaign',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_activecampaign.svg',
  },
  {
    name: 'ConvertKit',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_convertkit.svg',
  },
  {
    name: 'Patreon',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_patreon.svg',
  },
  {
    name: 'Drip',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_drip.svg',
  },
  {
    name: 'GoHighLevel',
    logo_url:
      'https://d12uehpv4khsa7.cloudfront.net/1755c2bb53e7df5ccb02ed59fb0428ead8156bba/assets/images/integrations/logo_gohighlevel.png',
  },
];
export interface AttributeListProps {
  attributes: Attribute[];
  status: QueryStatus;
}

export default function AttributeList({
  attributes,
  status,
}: AttributeListProps) {
  const { route } = useZiggy();

  if (status == 'error') {
    return (
      <>
        There was a problem loading attributes. Please check your automation
        settings.
      </>
    );
  }

  if (status == 'loading') {
    return <i className='far fa-spinner fa-spin' />;
  }

  if (attributes.length === 0) {
    return (
      <div className='flex flex-col gap-y-4'>
        <div
          className='flex justify-center items-center border border-dashed border-neutral-700 rounded-md px-4 py-12'
          style={{
            backgroundImage: 'url("/assets/images/attributes-hidden.png")',
            backgroundSize: 'auto calc(100% - 10px)',
            backgroundPosition: '5px 5px',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className='bg-white flex flex-col w-[80%] gap-y-4 border border-solid border-neutral-700 rounded-md p-4'>
            <div className='flex flex-col gap-y-2 text-center'>
              <span className='font-bold'>
                Want a greater impact and engagement?
              </span>
              <span>
                Connect your tools to display your own customer data for more
                specialized messages
              </span>
            </div>
            <a
              href={route('automation::index')}
              className='!v2-text-black w-full'
            >
              <Button variant='secondary' className='w-full '>
                <FontAwesomeIcon icon={faPlus} /> Connect now
              </Button>
            </a>
          </div>
        </div>
        <div className='flex justify-center w-full'>
          <div className='flex gap-3 flex-wrap justify-center'>
            {TOP_INTEGRATIONS.map((service) => (
              <div
                key={service.name}
                className='flex-shrink-0 border border-solid border-neutral-300 rounded-md p-1'
              >
                <Tooltip content={service.name}>
                  <img
                    src={service.logo_url}
                    alt={service.name}
                    title={service.name}
                    className='w-8 h-8'
                  />
                </Tooltip>
              </div>
            ))}
          </div>
        </div>
        <span className='text-center'>
          Bonjoro connects with all your other software &nbsp;
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='http://help.bonjoro.com/integrations-and-workflow/attributes-customise-your-bonjoros-with-crm-data'
          >
            See how
          </a>
        </span>
      </div>
    );
  }

  return (
    <div className='text-base flex flex-col gap-y-4'>
      {attributes.map((attribute) => (
        <AttributeListItem key={attribute.name} attribute={attribute} />
      ))}
    </div>
  );
}
